module.exports = __webpack_public_path__ + "public/img/Desktop-1.4029c6ed.png";